import { __awaiter, __generator } from "tslib";
import { Resource } from '@ekuaibao/fetch';
var staffAPI = new Resource('/api/v1/organization/staff');
export var getStaffFieldConfig = function () { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2, staffAPI.GET('/field/config')];
    });
}); };
export var getStaffInfoById = function (staffId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, staffAPI.GET("/field/info/$staffId", { staffId: staffId })];
    });
}); };
